import React, { useState, useEffect } from "react";
import { sbGetSetting, sbSetSetting } from "../utils/supabaseClient";
import "../styles/ListTab.css";

const LessonListTab = () => {
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  useEffect(() => {
    loadLessons();
  }, []);

  const loadLessons = async () => {
    try {
      setLoading(true);
      const data = await sbGetSetting("origamic-lessons");
      setLessons(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error loading lessons:", err);
      alert("Failed to load lessons");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this lesson?")) return;

    try {
      const updated = lessons.filter((l) => l.id !== id);
      await sbSetSetting("origamic-lessons", updated);
      setLessons(updated);
      alert("Lesson deleted successfully!");
    } catch (err) {
      console.error("Error deleting lesson:", err);
      alert("Failed to delete lesson");
    }
  };

  const handleEdit = (lesson) => {
    setEditingId(lesson.id);
    setEditFormData({ ...lesson });
  };

  const handleSaveEdit = async () => {
    try {
      const updated = lessons.map((l) =>
        l.id === editingId ? editFormData : l
      );
      await sbSetSetting("origamic-lessons", updated);
      setLessons(updated);
      setEditingId(null);
      alert("Lesson updated successfully!");
    } catch (err) {
      console.error("Error saving lesson:", err);
      alert("Failed to save lesson");
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditFormData({});
  };

  if (loading) return <div className="loading">Loading lessons...</div>;

  if (lessons.length === 0)
    return <div className="empty-state">No lessons found. Create one first!</div>;

  return (
    <div className="list-container">
      <h2>All Lessons ({lessons.length})</h2>

      {editingId ? (
        // Edit Form
        <div className="edit-form">
          <h3>Edit Lesson</h3>
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              value={editFormData.title || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, title: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Icon</label>
            <input
              type="text"
              value={editFormData.icon || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, icon: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Duration</label>
            <input
              type="text"
              value={editFormData.dur || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, dur: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Category/Tag</label>
            <input
              type="text"
              value={editFormData.tag || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, tag: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Subtitle</label>
            <textarea
              value={editFormData.subtitle || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, subtitle: e.target.value })
              }
              rows="3"
            />
          </div>
          <div className="form-actions">
            <button className="btn-save" onClick={handleSaveEdit}>
              💾 Save Changes
            </button>
            <button className="btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        // Lessons List
        <div className="items-grid">
          {[...lessons].sort((a, b) => new Date(b.addedAt || 0) - new Date(a.addedAt || 0)).map((lesson) => (
            <div key={lesson.id} className="item-card">
              <div className="item-icon">{lesson.icon}</div>
              <div className="item-content">
                <h4>{lesson.title}</h4>
                <p className="item-meta">
                  {lesson.tag} • {lesson.dur} • {lesson.addedAt ? new Date(lesson.addedAt).toLocaleDateString() : ""}
                </p>
                {lesson.subtitle && (
                  <p className="item-subtitle">{lesson.subtitle}</p>
                )}
                <p className="item-sections">
                  {lesson.body?.length || 0} sections
                </p>
                <div style={{display: "flex", gap: "8px", marginTop: "8px"}}>
                  {lesson.draft ? (
                    <div className="badge-draft">⚠️ DRAFT</div>
                  ) : (
                    <div style={{padding: "4px 12px", background: "#22C55E20", color: "#22C55E", borderRadius: "6px", fontSize: "12px", fontWeight: "600"}}>✓ PUBLISHED</div>
                  )}
                </div>
              </div>
              <div className="item-actions">
                <button
                  className="btn-edit"
                  onClick={() => handleEdit(lesson)}
                >
                  ✏️
                </button>
                <button
                  className="btn-delete"
                  onClick={() => handleDelete(lesson.id)}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LessonListTab;
